import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import { Link } from "react-router-dom";
import config from "../../config";

const CommunicationReport = () => {

    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);

    // pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const getReport = async () => {

        try {

            setLoading(true);

            const res = await axios.post(
                `${config.API_BASE_URL}communicationReport`
            );

            if (res.data.success === 1) {

                setUsers(res.data.data || []);

            } else {

                setUsers([]);

            }

        }
        catch (err) {

            console.log(err);

            setUsers([]);

        }
        finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        getReport();

    }, []);

    const downloadExcel = () => {

        const exportData = users.map((item, index) => ({

            "S.No": index + 1,

            "User Name": item.name,

            "User Role": item.role_name,

            "No. of Communication":
                item.total_communication,

            "Last Communication":
                item.last_communication

        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Communication Report"
        );

        XLSX.writeFile(
            workbook,
            "Communication_Report.xlsx"
        );

    };

    // ---------- pagination logic ----------

    const totalRows = users.length;

    const totalPages = Math.max(
        1,
        Math.ceil(totalRows / rowsPerPage)
    );

    const startIndex = (currentPage - 1) * rowsPerPage;

    const endIndex = Math.min(
        startIndex + rowsPerPage,
        totalRows
    );

    const paginatedUsers = users.slice(startIndex, endIndex);

    const handleRowsPerPageChange = (e) => {

        setRowsPerPage(Number(e.target.value));

        setCurrentPage(1);

    };

    const goToFirstPage = () => {

        setCurrentPage(1);

    };

    const goToPrevPage = () => {

        setCurrentPage((prev) => Math.max(prev - 1, 1));

    };

    const goToNextPage = () => {

        setCurrentPage((prev) => Math.min(prev + 1, totalPages));

    };

    const goToLastPage = () => {

        setCurrentPage(totalPages);

    };

    // ---------------------------------------

    return (

        <div className="container-fluid py-4">

            <div
                className="bg-white rounded-4 shadow-sm overflow-hidden"
                style={{
                    border: "1px solid #ececec"
                }}
            >

                <div className="d-flex justify-content-between align-items-center p-4">

                    <h3
                        className="fw-bold m-0"
                        style={{
                            color: "#1e293b"
                        }}
                    >
                        Communication Report
                    </h3>

                    <button
                        className="btn"
                        onClick={downloadExcel}
                        style={{
                            background: "#1D4ED8",
                            color: "#fff",
                            borderRadius: "10px",
                            padding: "8px 15px",
                            fontWeight: 600,
                            fontSize: "11px",
                            boxShadow:
                                "0 4px 14px rgba(29,78,216,.25)"
                        }}
                    >

                        <i className="bi bi-download me-2" />

                        DOWNLOAD REPORT

                    </button>

                </div>

                <div className="table-responsive">

                    <table className="table align-middle mb-0">

                        <thead
                            style={{
                                background: "#eef2ff"
                            }}
                        >

                            <tr>

                                <th>S.No</th>

                                <th>User Name</th>

                                <th>Email</th>

                                <th>User Role</th>

                                <th>No. of Communication</th>

                                <th>Last Communication</th>

                            </tr>

                        </thead>

                        <tbody>

                            {loading && (

                                <tr>

                                    <td
                                        colSpan="5"
                                        className="text-center py-4"
                                    >

                                        Loading...

                                    </td>

                                </tr>

                            )}

                            {!loading &&
                                users.length === 0 && (

                                    <tr>

                                        <td
                                            colSpan="5"
                                            className="text-center py-4"
                                        >

                                            No records found

                                        </td>

                                    </tr>

                                )}

                            {!loading &&
                                paginatedUsers.map((item, index) => (

                                    <tr
                                        key={
                                            item.user_id
                                        }
                                    >

                                        <td>

                                            {startIndex + index + 1}

                                        </td>

                                        <td className="fw-semibold">

                                            <Link
                                                to={`/dashboard/edit-user/${btoa(item.user_id)}`}
                                                style={{
                                                    color: "#2563EB",
                                                    textDecoration: "none",
                                                    fontWeight: 600
                                                }}
                                            >
                                                {item.name}
                                            </Link>

                                        </td>

                                        <td className="fw-semibold">

                                            {/* <Link
                                                to={`/dashboard/edit-user/${btoa(item.user_id)}`}
                                                style={{
                                                    color: "#2563EB",
                                                    textDecoration: "none",
                                                    fontWeight: 600
                                                }}
                                            > */}
                                                {item.email}
                                            {/* </Link> */}

                                        </td>

                                        <td>

                                            <span
                                                className="badge rounded-pill"
                                                style={{
                                                    background:
                                                        "#E0F2FE",

                                                    color:
                                                        "#0369A1",

                                                    padding:
                                                        "8px 14px"
                                                }}
                                            >

                                                {
                                                    item.role_name
                                                }

                                            </span>

                                        </td>

                                        <td
                                            className="fw-bold"
                                            style={{
                                                color:
                                                    "#2563EB"
                                            }}
                                        >

                                            {
                                                item.total_communication
                                            }

                                        </td>

                                        <td>
                                            {new Date(item.last_communication).toLocaleString(
                                                'en-GB',
                                                {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: true
                                                }
                                            )}
                                        </td>

                                    </tr>

                                ))}

                        </tbody>

                    </table>

                </div>

                {!loading && totalRows > 0 && (

                    <div
                        className="d-flex justify-content-end align-items-center p-3"
                        style={{
                            borderTop: "1px solid #ececec",
                            gap: "20px"
                        }}
                    >

                        <div className="d-flex align-items-center" style={{ gap: "8px" }}>

                            <span style={{ fontSize: "13px", color: "#475569" }}>
                                Rows per page:
                            </span>

                            <select
                                value={rowsPerPage}
                                onChange={handleRowsPerPageChange}
                                style={{
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "6px",
                                    padding: "4px 8px",
                                    fontSize: "13px",
                                    color: "#1e293b",
                                    background: "#fff"
                                }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>

                        </div>

                        <span style={{ fontSize: "13px", color: "#475569" }}>
                            {startIndex + 1}-{endIndex} of {totalRows}
                        </span>

                        <div className="d-flex align-items-center" style={{ gap: "4px" }}>

                            <button
                                onClick={goToFirstPage}
                                disabled={currentPage === 1}
                                className="btn btn-sm"
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    opacity: currentPage === 1 ? 0.4 : 1
                                }}
                            >
                                <i className="bi bi-chevron-bar-left" />
                            </button>

                            <button
                                onClick={goToPrevPage}
                                disabled={currentPage === 1}
                                className="btn btn-sm"
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    opacity: currentPage === 1 ? 0.4 : 1
                                }}
                            >
                                <i className="bi bi-chevron-left" />
                            </button>

                            <button
                                onClick={goToNextPage}
                                disabled={currentPage === totalPages}
                                className="btn btn-sm"
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    opacity: currentPage === totalPages ? 0.4 : 1
                                }}
                            >
                                <i className="bi bi-chevron-right" />
                            </button>

                            <button
                                onClick={goToLastPage}
                                disabled={currentPage === totalPages}
                                className="btn btn-sm"
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    opacity: currentPage === totalPages ? 0.4 : 1
                                }}
                            >
                                <i className="bi bi-chevron-bar-right" />
                            </button>

                        </div>

                    </div>

                )}

            </div>

        </div>

    );

};

export default CommunicationReport;